import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import Promo from './promo/promo';
import Article from './article/article';
import Constants from '../../common/constants';
import Util from '../../common/util';
import { IsEmpty } from '../../common/checks';
import apiService from '../../services.js/apiService';

const Post = ({ match, postId, redirectUrl, location }) => {
  const [loaded, setLoaded] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [type, setType] = useState(null);

  useEffect(() => {
    postId = postId || match.params.postId;
    async function fetchPostData() {
      const post = await apiService.getPostById(postId);
      if (post) {
        setType(post.type);
        setLoaded(true);
      }
    }
    fetchPostData();
  }, []);

  if (redirect) {
    let url = redirectUrl;
    if (!url) {
      const query = Util.ExtractParamsFromUrlQueryStr(location.search);
      if (!IsEmpty(query) && !IsEmpty(query.pageHighlightId)) {
        url = `/admin/page/${match.params.pageId}/highlight/${query.pageHighlightId}/posts?isExclusive=true`;
      } else {
        url = `/admin/page/${match.params.pageId}/posts`;
      }
    }
    return <Redirect to={url} />;
  } else {
    return !loaded ? <>Loading...</> : (
      <>
        {type === Constants.PostType.Promo
          ? <Promo pageId={match.params.pageId} match={match} onRedirect={() => setRedirect(true)} />
          : <Article pageId={match.params.pageId} match={match} onRedirect={() => setRedirect(true)} />}
      </>
    );
  }
};

Post.postTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  postInView: state.admin.post.postInView,
});

export default connect(mapStateToProps, { })(Post);
